export enum Odeur {
    Inconnu = 0,
    Sans = 1,
    Legere = 2,
    Forte = 3,
}
